import(/* webpackMode: "eager" */ "/var/www/telesky/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/telesky/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/telesky/src/app/news-updates/components/NewsUpdatesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/telesky/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/telesky/src/components/ui/AppIcon.tsx");
